import { useDispatch } from 'react-redux';

import type { CoreStoreDispatch } from './dispatch.type';

/** Use CoreStore Dispatch. */
export const useCoreStoreDispatch = useDispatch.withTypes<CoreStoreDispatch>();
